import React from 'react'
import {Box } from 'grommet'
import ListShipments from '../../components/listShipments'
import {withRouter} from 'react-router-dom'
import { NavigationSnackBar } from '../../components/utils/shared/shared'
function AllShipments (props) {
    return (
     <Box>
      <NavigationSnackBar title={'All Shipments'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
       <ListShipments user={props.user} displayQuote={props.displayQuote}/>
     </Box>
    )
}

export default withRouter(AllShipments)
